import React from 'react'

import {Divider, Dropdown, IconButton} from 'rsuite'
import {IconProps} from '@rsuite/icons/esm/Icon'
import {useTranslation} from 'react-i18next'

import Plus from '@rsuite/icons/legacy/Plus'
import Paste from '@rsuite/icons/legacy/Paste'

export interface MenuProps {
  readonly items: Array<MenuItem>

  onItemClick(item: MenuItem): void
}

export interface MenuItem {
  readonly id: string
  readonly icon: React.ReactElement<IconProps>
  readonly label?: string
  readonly labelI18n?: {[lang: string]: string}
}

export interface AddBlockInputProps {
  menuItems: Array<MenuItem>
  subtle?: boolean
  disabled?: boolean
  langUi?: string

  onMenuItemClick: (item: MenuItem) => void
  onPaste: () => void
}

export function AddBlockInput({
  menuItems,
  subtle,
  disabled,
  langUi,
  onMenuItemClick,
  onPaste,
}: AddBlockInputProps) {
  const {t} = useTranslation()
  return (
    <div
      style={{
        position: 'relative',
      }}>
      <Divider style={{margin: '40px 0'}}>
        <Dropdown
          disabled={disabled}
          renderToggle={(props, ref) => (
            <IconButton {...props} ref={ref} appearance="ghost" size="xs" icon={<Plus />} circle />
          )}>
          <Dropdown.Item onSelect={onPaste}>
            <Paste /> {t('blockList.paste')}
          </Dropdown.Item>
          {menuItems.map((item, index) => {
            const displayLabel =
              item.labelI18n && langUi ? item.labelI18n[langUi] || item.label : item.label
            return (
              <Dropdown.Item
                key={index}
                onSelect={(event) => {
                  onMenuItemClick(item)
                }}>
                {item.icon} {displayLabel}
              </Dropdown.Item>
            )
          })}
        </Dropdown>
      </Divider>
    </div>
  )
}
